import { EnvContribution, getLegacyBindingContext } from "@visactor/vrender-core";

import { bindFeishuCanvasModules } from "../canvas/contributions/feishu/modules";

import { bindFeishuWindowContribution } from "../window/contributions/feishu-contribution";

import { loadMathPicker } from "../picker/math-module";

import { FeishuEnvContribution } from "./contributions/feishu-contribution";

export function bindFeishuEnv(container) {
    var _a, _b;
    (null === (_b = (_a = container).isBound) || void 0 === _b ? void 0 : _b.call(_a, FeishuEnvContribution)) || (container.bind(FeishuEnvContribution).toSelf().inSingletonScope(), 
    container.bind(EnvContribution).toService(FeishuEnvContribution));
}

export function loadFeishuEnv(container = getLegacyBindingContext(), loadPicker = !0) {
    loadFeishuEnv.__loaded || (loadFeishuEnv.__loaded = !0, bindFeishuEnv(container), 
    bindFeishuCanvasModules(container), bindFeishuWindowContribution(container), loadPicker && loadMathPicker(container));
}

loadFeishuEnv.__loaded = !1;

export function initFeishuEnv() {
    loadFeishuEnv();
}
//# sourceMappingURL=feishu.js.map